import * as React from 'react';
import LoadingSpinner from '../../../LoadingSpinner';
import withLazyLoader from '../../../withLazyLoader';
import { ActivityChartProps } from '../../types';
import './ActivityChart.scss';

/** Placeholder for the map and chart while the code is dynamically loading */
export const LazyActivityChartPlaceholder = () => (
    <div className="activity-chart-container">
        <LoadingSpinner className="chart-loader" />
    </div>
);

/**
 * Returns a promise which lazy loads the activity chart component
 */
export const preloadActivityChart = async (): Promise<
    React.ComponentClass<any> | React.StatelessComponent<any>
> => {
    const component = await import(/* webpackChunkName: "activity_chart" */ './ActivityChart');
    return component.default as
        | React.ComponentClass<any>
        | React.StatelessComponent<any>;
};

/** Use withProps to inject the preloading function into the lazy load component */
const LazyActivityChart = withLazyLoader<ActivityChartProps>(
    {
        lazyLoadComponent: preloadActivityChart
    },
    LazyActivityChartPlaceholder
);

/** Get data for the map before lazy loading, so data is loaded in parallel */
export default LazyActivityChart;



// WEBPACK FOOTER //
// ./src/client/components/Strava/ActivityScene/ActivityChart/LazyActivityChart.tsx